export const getInitials = function (text:string) {
    var words = text.split(' ');
    var initials = words.map(word => word[0]).join('');
    return initials;
}